module.exports = __webpack_public_path__ + "img/jiaoyu_fengdong_suoluetu.0e3c53fa.png";